module.exports = __webpack_public_path__ + "segment-icon-fcd874154d55ba372372.svg";